import { useState } from "react";
import { Link } from "react-router-dom";
import { EnvelopeSimple } from "@phosphor-icons/react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(null);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email.trim())) {
      setError("That does not look like an email address");
      setBusy(false);
      return;
    }
    try {
      const { data } = await api.post("/security/forgot-password", { email: email.trim() });
      setSent(data.message);
    } catch (err) {
      setError(formatApiErrorDetail(err?.response?.data?.detail));
    } finally { setBusy(false); }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#F7F7F5] px-5 py-12" data-testid="forgot-page">
      <div className="w-full max-w-md border border-border bg-white p-7">
        <p className="overline text-[#B3241B]">Unity &amp; Utility</p>
        <h1 className="font-display mt-2 text-3xl font-bold tracking-tight text-[#0F172A]">
          Forgotten your password?
        </h1>
        <p className="mt-3 text-sm text-slate-600">
          Put in the email you sign in with and we will send you a link to choose a new
          password. The link works once and expires in 30 minutes.
        </p>

        {sent ? (
          <p data-testid="forgot-sent" className="mt-6 border-l-2 border-[#0F7A3D] bg-[#EAF7EF] px-4 py-3 text-sm text-[#0B5C2E]">
            {sent}
          </p>
        ) : (
          <form className="mt-6 space-y-4" onSubmit={submit}>
            <div>
              <Label htmlFor="email" className="overline text-slate-500">Email</Label>
              <Input id="email" data-testid="forgot-email-input" type="email" value={email} required
                onChange={(e) => setEmail(e.target.value)} placeholder="you@company.com" className="mt-1" />
            </div>
            {error && (
              <p data-testid="forgot-error" className="border-l-2 border-[#B3241B] bg-[#FFF1F0] px-3 py-2 text-sm text-[#8E1C15]">{error}</p>
            )}
            <Button type="submit" data-testid="forgot-submit" className="w-full" disabled={busy || email.trim().length < 5}>
              <EnvelopeSimple size={16} className="mr-1.5" /> {busy ? "Sending…" : "Send me a reset link"}
            </Button>
          </form>
        )}

        <p className="mt-6 text-sm text-slate-600">
          <Link to="/login" data-testid="forgot-back-to-login" className="tap-safe font-semibold text-[#002FA7] hover:underline">
            Back to sign in
          </Link>
        </p>
      </div>
    </div>
  );
}
